<script>
import moment from 'moment';
import axios from 'axios';
import each from 'lodash/each';
import get from 'lodash/get';
import defer from 'lodash/defer';
import Vue from 'vue';
import { mapState } from 'vuex';
import { UiSnackbar, UiSnackbarContainer } from 'keen-ui';

import * as config from './config';
import Logo from './components/Logo';

Vue.mixin({
  methods: {
    updateState(state, property, value) {
      this.$store.commit('update', { state, property, value });
    },
  },
});

export default {
  components: {
    Logo,
    UiSnackbar,
    UiSnackbarContainer,
  },
  data: () => ({
    open: false,
    ready: false,
    menuHeight: 0,
  }),
  computed: {
    ...mapState({
      jwt: state => state.jwt,
    }),
  },
  async created() {
    axios.interceptors.request.use(config => {
      config.headers['Authorization'] = `Bearer ${this.jwt}`;

      return config;
    }, e => {
      throw e;
    });

    axios.interceptors.response.use(res => res, async e => {
      if (e.response.status === 401) {
        this.logout();
      } else if (e.response.status === 403) {
        this.updateState(this.$store.state, 'user', e.response.data);

        try {
          await this.$router.push({ name: 'pending' });
        } catch {}
      } else {
        if (get(e, 'response.data.errors')) {
          each(e.response.data.errors, error => {
            this.$refs.snackbarContainer.createSnackbar({
              message: error,
            });
          });
        } else if (get(e, 'response.data.message')) {
          this.$refs.snackbarContainer.createSnackbar({
            message: e.response.data.message,
          });
        } {
          console.error(e);
        }

        throw e;
      }
    });

    if (!window.location.href.includes('slideshow')) {
      try {
        await this.$store.dispatch('getCurrentUser');
      } catch (e) {
        this.$router.push({ name: 'login' });
      }

      this.ready = true;

      this.menuHeight = `${this.$refs.navMenu.scrollHeight}px`;
    } else {
      this.ready = true;
    }
  },
  methods: {
    async logout() {
      this.open = false;

      this.updateState(this.$store.state, 'jwt', null);

      this.updateState(this.$store.state, 'user', null);

      localStorage.removeItem('jwt');

      try {
        await this.$router.push({ name: 'login' });
      } catch (e) {}
    },
  },
};
</script>

<template lang="pug">
.bg-dark.flex.flex-wrap.md_flex-no-wrap.md_min-h-screen
  .w-full.md_w-14.bg-dark-side.flex-shrink-0(v-show='$route.name !== "slideshow"')

    .flex.flex-col.select-none
      .flex.items-center.my-_5.md_my-0.md_mt-1
        .w-1-4.px-1.md_hidden(@click='open = !open')
          template(v-if='!["login", "register"].includes($route.name) && $store.state.user')
            svg.text-white.h-2(v-show='!open', viewBox='0 0 24 24')
              path.fill-current(d='M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z')
            svg.text-white.h-2(v-show='open', viewBox='0 0 24 24')
              path.fill-current(d='M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z')

        .w-2-4.md_w-full.flex.justify-center
          logo.h-3.md_h-4.lg_h-5

      .overflow-hidden.transition-all.transition-100(
        ref='navMenu'
        :style='{ height: open || !["sm", "md"].includes($mq) ? menuHeight : 0 }',
      )
        template(v-if='!["login", "register"].includes($route.name) && $store.state.user && $store.state.user.approved')
          .mx-1
            router-link.mt-1.py-_75.px-1.text-dark-text.flex.items-center.transition-all.hover_text-white.rounded-lg(:to='{ name: "activity" }')
              svg.h-1_5.mr-_5(viewBox='0 0 24 24')
                path.fill-current(d='M3,13H5.79L10.1,4.79L11.28,13.75L14.5,9.66L17.83,13H21V15H17L14.67,12.67L9.92,18.73L8.94,11.31L7,15H3V13Z')
              div Activity

          .mx-1
            router-link.py-_75.px-1.text-dark-text.flex.items-center.transition-all.hover_text-white.rounded-lg(
              :class='{ "router-link-active": $route.name === "animal" }',
              :to='{ name: "animals" }',
            )
              svg.h-1_5.mr-_5(viewBox='0 0 24 24')
                path.fill-current(d='M8.35,3C9.53,2.83 10.78,4.12 11.14,5.9C11.5,7.67 10.85,9.25 9.67,9.43C8.5,9.61 7.24,8.32 6.87,6.54C6.5,4.77 7.17,3.19 8.35,3M15.5,3C16.69,3.19 17.35,4.77 17,6.54C16.62,8.32 15.37,9.61 14.19,9.43C13,9.25 12.35,7.67 12.72,5.9C13.08,4.12 14.33,2.83 15.5,3M3,7.6C4.14,7.11 5.69,8 6.5,9.55C7.26,11.13 7,12.79 5.87,13.28C4.74,13.77 3.2,12.89 2.41,11.32C1.62,9.75 1.9,8.08 3,7.6M21,7.6C22.1,8.08 22.38,9.75 21.59,11.32C20.8,12.89 19.26,13.77 18.13,13.28C17,12.79 16.74,11.13 17.5,9.55C18.31,8 19.86,7.11 21,7.6M19.33,18.38C19.37,19.32 18.65,20.36 17.79,20.75C16,21.57 13.88,19.87 11.89,19.87C9.9,19.87 7.76,21.64 6,20.75C5,20.26 4.31,18.96 4.44,17.88C4.62,16.39 6.41,15.59 7.47,14.5C8.88,13.09 9.88,10.44 11.89,10.44C13.89,10.44 14.95,13.05 16.3,14.5C17.41,15.72 19.26,16.75 19.33,18.38Z')
              div Animals

          .mx-1
            router-link.py-_75.px-1.text-dark-text.flex.items-center.transition-all.hover_text-white.rounded-lg(:to='{ name: "adoptions" }')
              svg.h-1_5.mr-_5(viewBox='0 0 24 24')
                path.fill-current(d='M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z')
              div Adoptions

        .mx-1(v-if='$store.state.user')
          .py-_75.px-1.text-dark-text.flex.items-center.transition-all.hover_text-white.rounded-lg(@click='logout')
            svg.h-1_5.mr-_5(viewBox='0 0 24 24')
              path.fill-current(d='M16,17V14H9V10H16V7L21,12L16,17M14,2A2,2 0 0,1 16,4V6H14V4H5V20H14V18H16V20A2,2 0 0,1 14,22H5A2,2 0 0,1 3,20V4A2,2 0 0,1 5,2H14Z')
            div Log Out

  router-view.w-full(v-if='ready')
  ui-snackbar-container(
    ref='snackbarContainer',
    position='right',
    :duration='parseInt(2000)',
    :queue-snackbars='true',
  )
</template>

<style>
@font-face {
  font-family: 'allura';
  src: url('./assets/fonts/allura-regular-webfont.woff2') format('woff2'),
    url('./assets/fonts/allura-regular-webfont.woff') format('woff');
  font-weight: normal;
  font-style: normal;
}

.display-font {
  font-family: 'allura';
}

.transition-all {
  transition: all 250ms linear;
}

.router-link-active {
  background-color: #282828;
  color: white;
}

.ui-textbox__input,
.ui-textbox__textarea,
.ui-alert__body {
  color: white;
}

.ui-checkbox .ui-checkbox__label-text {
  @apply text-sm;
}

.ui-textbox__input,
.ui-textbox:hover:not(.is-disabled) .ui-textbox__input,
.ui-select__display,
.ui-select:hover:not(.is-disabled) .ui-select__display {
  border-bottom-color: #b3b3b3;
}

.ui-textbox.has-floating-label .ui-textbox__label-text.is-inline,
.ui-textbox:hover:not(.is-disabled) .ui-textbox__label-text,
.ui-textbox__label-text,
.ui-select__label-text,
.ui-select__display,
.ui-select:hover:not(.is-disabled) .ui-select__dropdown-button,
.ui-select:hover:not(.is-disabled) .ui-select__label-text,
.ui-select:hover:not(.is-disabled) .ui-select__display,
.ui-select__dropdown-button,
.ui-checkbox .ui-checkbox__checkmark,
.ui-checkbox .ui-checkbox__label-text {
  color: #b3b3b3;
}

.ui-select__options {
  background-color: #121212;
  color: white;
}

.ui-select-option.is-highlighted {
  background-color: rgba(255, 255, 255, .1);
}

.ui-alert--type-warning .ui-alert__body {
  background-color: #2b2b2b;
}

.ui-checkbox__checkmark {
  background-color: rgba(255, 255, 255, .25);
}

.account {
  min-height: calc(100vh - 4rem);
}
</style>
